// Barra de rolagem própria (.sb-scroll do _sidebar.scss): só aparece com o mouse na coluna ou rolando.
// D35 v17 G-M9a: de singleton do menu lateral para fábrica. `ligar(el, {observar})` desenha o trilho dentro de `el` (contêiner rolável
// com position) e devolve {atualizar, soltar}; `observar` = nós (ou seletores) cujo tamanho muda sem o contêiner mudar (a lista que cresce).
// `init(nav)` / `atualizar()` continuam iguais para o SidebarNav (o menu é a instância padrão).
const $ = window.jQuery;

const MIN = 24;

const ligar = function (el, opcoes) {
    if (!el) return null;
    const op = opcoes || {};
    const trilho = $('<div class="sb-scroll"><div class="sb-thumb"></div></div>').appendTo(el)[0];
    const polegar = trilho.firstChild;
    let timer = null, arrastando = false, origemY = 0, origemScroll = 0;

    const atualizar = function () {
        const visivel = el.clientHeight, total = el.scrollHeight;
        const precisa = total > visivel + 1;
        trilho.dataset.precisa = precisa ? 'true' : 'false';
        if (!precisa) return;
        const alt = Math.max(MIN, Math.round(visivel * visivel / total));
        const pos = Math.round((visivel - alt) * el.scrollTop / (total - visivel));
        polegar.style.height = alt + 'px';
        polegar.style.transform = 'translateY(' + pos + 'px)';
        trilho.style.transform = 'translateY(' + el.scrollTop + 'px)';
    };
    const aoRolar = () => {
        atualizar();
        trilho.dataset.rolando = 'true';
        clearTimeout(timer);
        timer = setTimeout(() => { trilho.dataset.rolando = 'false'; }, 700);
    };
    const pegar = (e) => {
        arrastando = true; origemY = e.clientY; origemScroll = el.scrollTop;
        polegar.dataset.arrastando = 'true';
        e.preventDefault();
    };
    const mover = (e) => {
        if (!arrastando) return;
        const visivel = el.clientHeight, total = el.scrollHeight;
        const livre = visivel - Math.max(MIN, Math.round(visivel * visivel / total));
        if (livre > 0) el.scrollTop = origemScroll + (e.clientY - origemY) * (total - visivel) / livre;
    };
    const largar = () => {
        if (!arrastando) return;
        arrastando = false;
        polegar.dataset.arrastando = 'false';
    };

    el.addEventListener('scroll', aoRolar, { passive: true });
    window.addEventListener('resize', atualizar);
    polegar.addEventListener('mousedown', pegar);
    document.addEventListener('mousemove', mover);
    document.addEventListener('mouseup', largar);
    let ro = null;
    if (window.ResizeObserver) {
        ro = new ResizeObserver(atualizar);
        ro.observe(el);
        (op.observar || []).forEach((n) => {
            const no = typeof n === 'string' ? document.querySelector(n) : n;
            if (no) ro.observe(no);
        });
    }
    atualizar();

    const soltar = function () {
        clearTimeout(timer);
        el.removeEventListener('scroll', aoRolar);
        window.removeEventListener('resize', atualizar);
        document.removeEventListener('mousemove', mover);
        document.removeEventListener('mouseup', largar);
        if (ro) ro.disconnect();
        trilho.remove();
    };
    return { atualizar: atualizar, soltar: soltar, trilho: trilho };
};

const NavScroll = function () {
    let padrao = null;   // o menu lateral (SidebarNav)
    return {
        ligar: ligar,
        init: function (el) { if (el) padrao = ligar(el); },
        atualizar: function () { if (padrao) padrao.atualizar(); },
    };
}();

module.exports = NavScroll;
